// extracted by mini-css-extract-plugin
export default {"container":"styles_container__u4OOk","button":"styles_button__o8Mhv","desc":"styles_desc__vLzh9","link":"styles_link__aOyiH","tv":"styles_tv__tKZ3N"};